import { getLocations } from '@/data/location/selectors';
import { getCurrentRange } from '@/scheduler/selectors/getCurrentViewMode';
import {
  DEFAULT_LOCATION_SORT_FILTER,
  getStateLocationSort,
  type SchedulerSortOption,
} from '@/scheduler/selectors/getLocationSort';
import type { WiwDispatch, WiwGetState } from '@/store';
import { CHANGE_EMPLOYEE_SORT } from '@/store/action-types';

export function changeSortFilter(locationId: number, sortOption: SchedulerSortOption) {
  return (dispatch: WiwDispatch, getState: WiwGetState) => {
    const state = getState();
    const locations = getLocations(state);
    const currentRange = getCurrentRange(state);
    const locationSort = getStateLocationSort(state);

    const currentLocationSort = locationSort.get(`${locationId}`, DEFAULT_LOCATION_SORT_FILTER);

    // WIWJS-7834 some user's metadata became malformed where the keys of the locationSort were being set to
    // immutable js's internals. This should undo that by cleansing scheduler.locationSort in the store which is then
    // used to update the user's metadata
    const filteredLocationSort = locationSort.filter((_: any, locationId: string) => {
      return locations.has(Number.parseInt(locationId, 10));
    });

    // Update the sort for the provided location
    const updatedLocationSort = filteredLocationSort.set(`${locationId}`, {
      ...currentLocationSort,
      [currentRange]: sortOption,
    });

    return dispatch({
      type: CHANGE_EMPLOYEE_SORT,
      payload: updatedLocationSort,
    });
  };
}
